import styled from 'styled-components';

export const Container = styled.main`
  position: relative;
  font-family: ${({ theme }) => theme.fonts.citiSans};
  background: ${({ theme }) => theme.colors.background};
  background-size: cover;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  color: ${({ theme }) => theme.colors.white};
  & > div {
    margin-bottom: ${({ theme }) => theme.getValue(35)};
  }
  & h2 {
    margin: 0;
    padding-top: ${({ theme }) => theme.getValue(27)};
    font-weight: 400;
    font-size: ${({ theme }) => theme.getFontSize(32)};
    line-height: 1.2;
    text-align: center;
  }
  & h1 {
    margin: 0;
    font-weight: 400;
    font-size: ${({ theme }) => theme.getFontSize(80)};
    line-height: 1.1;
    text-align: center;
  }
`;
